module.exports = __webpack_public_path__ + "static/img/bg9.a32b3d37.png";